import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-small-title',
  templateUrl: './small-title.component.html',
  styleUrls: ['./small-title.component.scss']
})
export class SmallTitleComponent implements OnInit {
  @Input() title: string = '小标题';
  @Input() linkUrl: string; //是否此案时路由
  @Input() borderLeft: boolean = true;
  @Input() borderBottom: boolean = false;
  @Input() fontSize = "16px";
  @Input() link: string; //路由

  constructor(
    private _router: Router,
  ) { }

  ngOnInit() {
  }

  //路由跳转
  gotopage() {
    this._router.navigate([this.link]);
  }

}






// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/small-title/small-title.component.ts